/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/8/2022
 */



import BaseDataFilter from "@/core/js/backend/filters/BaseDataFilter";

export default class DataFilterOrderBy extends BaseDataFilter {


	constructor(orderBy = "createdAt") {
		super()
		if(orderBy){
			this.orderByDesc(orderBy)
		}
	}

}
